var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { useSelector } from "react-redux";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { Row, Col } from "react-bootstrap";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import ReportValue from "@frameworks/shared-library/components/commonTableVal";
var SubscriptionDetails = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState([false]), 2), openDetails = _e[0], setopenDetails = _e[1];
    var _f = __read(React.useState([]), 2), historyDetails = _f[0], sethistoryDetails = _f[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var ADBtableSublist = [
        {
            title: "Criteria",
            key: "Criteria",
        },
        {
            title: "As on Date",
            key: "AsonDate",
        },
        {
            title: "Vol Del",
            key: "VolDel",
        },
        {
            title: "Vol Id",
            key: "VolId",
        },
        {
            title: "Vol Fut",
            key: "VolFut",
        },
        {
            title: "Vol Opt",
            key: "VolOpt",
        },
        {
            title: "Vol CDS",
            key: "VolCDS",
        },
        {
            title: "Vol COM",
            key: "VolCOM",
        },
        {
            title: "Tot Vol",
            key: "TotVol",
        },
        {
            title: "AB Consumed",
            key: "ABConsumed",
        },
        {
            title: "Free Period",
            key: "FreePeriod",
        },
        {
            title: "Vol Ofs",
            key: "VolOfs",
        },
        {
            title: "Action",
            key: "Action",
        },
    ];
    var getClientBrokerageDetails = function (accode, schemeRef, date, idx) { return __awaiter(void 0, void 0, void 0, function () {
        var result, temp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, props.detailsFunction({
                        accode: accode,
                        SchemeRefNo: schemeRef,
                        OnDate: date,
                    })];
                case 1:
                    result = _a.sent();
                    if (result && result[0]) {
                        temp = __spreadArray([], __read(historyDetails), false);
                        temp[idx] = result[0];
                        sethistoryDetails(temp);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("table", null,
        React.createElement("thead", null,
            React.createElement("tr", { className: "profile-main-tablebody-sub-tr-heading " }, ADBtableSublist.map(function (items) {
                return (React.createElement("th", { className: "DMSansMedium_12_500  txt_primaryGrey " }, items.title));
            }))),
        React.createElement("tbody", { className: "brd-tr-none" }, ((_a = props.data) === null || _a === void 0 ? void 0 : _a.ladB_BalanceConsumHistory) &&
            ((_c = (_b = props.data) === null || _b === void 0 ? void 0 : _b.ladB_BalanceConsumHistory) === null || _c === void 0 ? void 0 : _c.length) > 0 ? ((_d = props.data) === null || _d === void 0 ? void 0 : _d.ladB_BalanceConsumHistory.map(function (leabBalance, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
            return (React.createElement(React.Fragment, null,
                React.createElement("tr", { className: "profile-main-tablebody-sub-tr-tbody RobotoM_14_500", key: idx },
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.tO_Criteria),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.as_On_Date),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.vol_Del),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.vol_Id),
                    React.createElement("td", null,
                        " ",
                        React.createElement(ReportValue, { val: leabBalance.vol_Fut, stream: false, onlyval: false })),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.vol_Opt),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.vol_CDS),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.vol_Com),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.tot_Vol),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.aB_consumed),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.free_period),
                    React.createElement("td", null, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.voL_OFS),
                    React.createElement("td", null,
                        React.createElement("div", { className: "dpbtn-block" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Details", onClick: function () {
                                    var temp = __spreadArray([], __read(openDetails), false);
                                    temp[idx] = !temp[idx];
                                    setopenDetails(temp);
                                    temp[idx] &&
                                        getClientBrokerageDetails(leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.acCode, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.schemeRefno, leabBalance === null || leabBalance === void 0 ? void 0 : leabBalance.as_On_Date, idx);
                                } })))),
                openDetails[idx] && (React.createElement("tr", null,
                    React.createElement("td", { colSpan: 13, className: "p-0 border-top-0" },
                        React.createElement("div", { className: "bg_aqua_white DMSans_16_500 txt_blackOne1 py-2 px-3" }, "Subscription History Details"),
                        React.createElement("div", { className: "dailyconsumption-text d-flex justify-content-between py-2 px-3" },
                            React.createElement("div", { className: "DMSanN_16_400" },
                                "Details of Daily Consumption as on Date",
                                " ", leabBalance === null || leabBalance === void 0 ? void 0 :
                                leabBalance.as_On_Date,
                                "\u00A0 for Account Code",
                                " ",
                                React.createElement("label", { className: "DMSan_16_700" }, selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)),
                            React.createElement("div", { className: "txt_bloodRed" }, "*Red colored text shows 'overshoot At' Value")),
                        React.createElement(Row, { className: "subscription-details m-0" },
                            React.createElement(Col, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, { className: "name" },
                                        React.createElement("div", null, "Vol_del"),
                                        React.createElement("div", null, "Vol_ID"),
                                        React.createElement("div", null, "Vol_del_MTF"),
                                        React.createElement("div", null, "Vol_ID_MTF"),
                                        React.createElement("div", null, "Vol_Fut"),
                                        React.createElement("div", null, "Vol_CDS"),
                                        React.createElement("div", null, "Vol_Ofs"),
                                        React.createElement("div", null, "Lots_Opt"),
                                        React.createElement("div", null, "Lots_CDS"),
                                        React.createElement("div", null, "Total Del Cash")),
                                    React.createElement(Col, { className: "value" },
                                        React.createElement("div", null, addDashIfNullOrUndefined((_a = historyDetails[idx]) === null || _a === void 0 ? void 0 : _a.voL_del)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_b = historyDetails[idx]) === null || _b === void 0 ? void 0 : _b.voL_ID)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_c = historyDetails[idx]) === null || _c === void 0 ? void 0 : _c.voL_del_MTF)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_d = historyDetails[idx]) === null || _d === void 0 ? void 0 : _d.voL_ID_MTF)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_e = historyDetails[idx]) === null || _e === void 0 ? void 0 : _e.voL_Fut)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_f = historyDetails[idx]) === null || _f === void 0 ? void 0 : _f.voL_CDS)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_g = historyDetails[idx]) === null || _g === void 0 ? void 0 : _g.voL_OFS)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_h = historyDetails[idx]) === null || _h === void 0 ? void 0 : _h.lots_Opt)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_j = historyDetails[idx]) === null || _j === void 0 ? void 0 : _j.lots_CDS)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_k = historyDetails[idx]) === null || _k === void 0 ? void 0 : _k.total_del_Cash))))),
                            React.createElement(Col, null,
                                React.createElement(Row, null,
                                    " ",
                                    React.createElement(Col, { className: "name" },
                                        React.createElement("div", null, "Total ID Cash"),
                                        React.createElement("div", null, "AB Consumed"),
                                        React.createElement("div", null, "AB Cash"),
                                        React.createElement("div", null, "AB del"),
                                        React.createElement("div", null, "AB Fut"),
                                        React.createElement("div", null, "AB Opt"),
                                        React.createElement("div", null, "AB CDS"),
                                        React.createElement("div", null, "AB CDS OPT"),
                                        React.createElement("div", null, "AB TOT"),
                                        React.createElement("div", null, "AB ID")),
                                    React.createElement(Col, { className: "value" },
                                        React.createElement("div", null, addDashIfNullOrUndefined((_l = historyDetails[idx]) === null || _l === void 0 ? void 0 : _l.total_ID_Cash)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_m = historyDetails[idx]) === null || _m === void 0 ? void 0 : _m.aB_Consumed)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_o = historyDetails[idx]) === null || _o === void 0 ? void 0 : _o.aB_Cash)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_p = historyDetails[idx]) === null || _p === void 0 ? void 0 : _p.aB_Del)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_q = historyDetails[idx]) === null || _q === void 0 ? void 0 : _q.aB_Fut)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_r = historyDetails[idx]) === null || _r === void 0 ? void 0 : _r.aB_Opt)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_s = historyDetails[idx]) === null || _s === void 0 ? void 0 : _s.aB_CDS)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_t = historyDetails[idx]) === null || _t === void 0 ? void 0 : _t.aB_CDS_OPT)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_u = historyDetails[idx]) === null || _u === void 0 ? void 0 : _u.aB_TOT)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_v = historyDetails[idx]) === null || _v === void 0 ? void 0 : _v.aB_ID))))),
                            React.createElement(Col, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, { className: "name" },
                                        React.createElement("div", null, "AB TOT PFP"),
                                        React.createElement("div", null, "AB Excess"),
                                        React.createElement("div", null, "AB Ofs"),
                                        React.createElement("div", null, "Unique no of orders cash"),
                                        React.createElement("div", null, "Unique no of orders total Cash"),
                                        React.createElement("div", null, "Unique no of orders MTF"),
                                        React.createElement("div", null, "Unique no of orders OPT"),
                                        React.createElement("div", null, "Unique no of orders FUT"),
                                        React.createElement("div", null, "Unique no of orders CDS"),
                                        React.createElement("div", null, "Unique no of orders CDS OPT")),
                                    React.createElement(Col, { className: "value" },
                                        React.createElement("div", null, addDashIfNullOrUndefined((_w = historyDetails[idx]) === null || _w === void 0 ? void 0 : _w.aB_TOT_PFP)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_x = historyDetails[idx]) === null || _x === void 0 ? void 0 : _x.aB_Excess)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_y = historyDetails[idx]) === null || _y === void 0 ? void 0 : _y.aB_OFS)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_z = historyDetails[idx]) === null || _z === void 0 ? void 0 : _z.unique_NoOfOrders_Cash)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_0 = historyDetails[idx]) === null || _0 === void 0 ? void 0 : _0.unique_NoOfOrders_Total_Cash)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_1 = historyDetails[idx]) === null || _1 === void 0 ? void 0 : _1.unique_NoOfOrders_MTF)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_2 = historyDetails[idx]) === null || _2 === void 0 ? void 0 : _2.uniquE_NOOFORDERS_OPT)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_3 = historyDetails[idx]) === null || _3 === void 0 ? void 0 : _3.uniquE_NOOFORDERS_FUT)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_4 = historyDetails[idx]) === null || _4 === void 0 ? void 0 : _4.uniquE_NOOFORDERS_CDS)),
                                        React.createElement("div", null, addDashIfNullOrUndefined((_5 = historyDetails[idx]) === null || _5 === void 0 ? void 0 : _5.uniquE_NOOFORDERS_CDS_OPT)))))),
                        React.createElement("div", { className: "DMSanN_14_400 priority d-flex align-items-center" },
                            React.createElement("span", { className: "DMSan_14_500 pe-3" }, "Priority"),
                            React.createElement("div", null, " 1.Del "),
                            " ",
                            React.createElement("div", null, " 2.ID "),
                            " ",
                            React.createElement("div", null, " 3.Fut "),
                            React.createElement("div", null, " 4.Opt "),
                            " ",
                            React.createElement("div", null, "5.CDS-Fut "),
                            React.createElement("div", null, " 6.CDS-Pot ")))))));
        })) : (React.createElement("tr", null,
            React.createElement("td", { colSpan: 13 },
                React.createElement(Errormsg, { msg: "No Data Found" })))))));
};
export default SubscriptionDetails;
